import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProductListLayer from "../components/ProductListLayer";

const ProductListPage = () => {
  return (
    <>
      <MasterLayout>
        <ProductListLayer />
      </MasterLayout>
    </>
  );
};

export default ProductListPage;
